import React from "react";
import { Car } from "lucide-react";

/** Branded neutral placeholder for missing/failed vehicle images. */
export const ImagePlaceholder = ({ className = "", label = "Image coming soon" }) => (
  <div
    className={`w-full h-full flex flex-col items-center justify-center bg-[#F7F6F3] text-[#242424]/60 ${className}`}
    data-testid="image-placeholder"
    role="img"
    aria-label={label}
  >
    <div className="relative">
      <Car size={48} strokeWidth={1.25} className="opacity-60" />
      <span className="absolute -bottom-1 -right-1 h-2 w-2 rounded-full bg-[#7A1519]" aria-hidden="true" />
    </div>
    <div className="mt-4 overline text-[10px] tracking-[0.28em] text-[#242424]/50">Autobahn Cars</div>
    <div className="mt-1 text-xs">{label}</div>
  </div>
);

export default ImagePlaceholder;
